import React from 'react';
import { Card, Skeleton } from 'antd';
import { trpc } from '../../lib/trpc';
import BranchManagementTab from '../../components/company/BranchManagementTab';
import { PageHeader, PageContainer, DevFilePathBadge } from '../../components/common';

const BranchManagementPage: React.FC = () => {
  const { data: company, isLoading } = trpc.company.getCurrentCompany.useQuery();
  const { data: currentUser } = trpc.user.getProfile.useQuery();
  const isManager = currentUser?.role === 'admin' || currentUser?.role === 'manager';

  if (isLoading) {
    return (
      <PageContainer>
        <PageHeader
          title="拠点管理"
          subtitle="拠点の追加・編集・削除を行います"
        />
        <Card>
          <Skeleton active />
        </Card>
      </PageContainer>
    );
  }

  if (!company) {
    return (
      <PageContainer>
        <PageHeader
          title="拠点管理"
          subtitle="拠点の追加・編集・削除を行います"
        />
        <Card>
          <p>会社情報が見つかりません。</p>
        </Card>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <DevFilePathBadge filePath="client/src/pages/settings/BranchManagementPage.tsx" />
      <PageHeader
        title="拠点管理"
        subtitle="拠点の追加・編集・削除を行います"
      />
      <Card>
        <BranchManagementTab
          companyId={company.id}
          isManager={isManager}
          canAdd={true}
          canEditMap={true}
        />
      </Card>
    </PageContainer>
  );
};

export default BranchManagementPage;
